import { breakpoints } from 'assets/tokens.json';

export function matchBreakpoint(id) {
  return window.matchMedia(`(min-width: ${breakpoints[id]})`);
}
